import { styled } from '@clickcease/cc-client-components-lib'

export const MultiDomainsContainer = styled('div', {
  width: '600px',
  height: 'calc(100% - 40px)',
  padding: '$10',
  display: 'flex',
  flexDirection: 'column',
})

export const StepperWrapper = styled('div', {
  width: '50%',
})

export const DescriptionBlock = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingBlock: '$12',
  gap: '$2',
})

export const FooterContainer = styled('div', {
  justifyContent: 'flex-end',
  display: 'flex',
  marginTop: 'auto',
  gap: '$8',
})

export const DomainsToProductsContainer = styled('div', {
  marginTop: '$12',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'space-between',
})

export const DomainsToProductsCard = styled('div', {
  boxShadow: '$card',
  border: '1px solid $veryLightNeutral',
  borderRadius: '$2',
  padding: '$10',
  overflowY: 'auto',
  width: '560px',
  height: '330px',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
})

export const DomainsToProductsCardRow = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingBlock: '$4',
  borderBottom: '1px solid $veryLightNeutral',

  variants: {
    isHeader: {
      true: {
        borderBottom: '1px solid $lightNeutral',
      },
    },
  },
})

export const MessageBoxContainer = styled('div', {
  maxWidth: '600px',
  position: 'absolute',
  bottom: '55px',
  display: 'flex',
  justifyContent: 'center',

  variants: {
    singleDomainVariant: {
      true: {
        width: '500px',
        marginLeft: '$7',
        bottom: '80px',
      },
    },
  },
})
